var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-inner"},[_c('KakaoButton',{on:{"kakaoSignUp":_vm.kakaoSignUp,"kakaoSignIn":_vm.kakaoSignIn}}),_c('v-btn',{attrs:{"color":"primary","x-large":"","outlined":"","block":"","rounded":""},on:{"click":_vm.gotoSignIn}},[_vm._v(" 회원가입 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }